module.exports = __webpack_public_path__ + "static/media/person-manage.32a80d83.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/person-manage.png
// module id = 1933
// module chunks = 6